export default __webpack_public_path__ + "static/media/paw-print-pin-gray.a79e61dd.svg";